import React, {FC} from 'react'
import {IProductProps, productActionType} from '../../cors/reducers'
import SortableImages from '../../components/SortableImages'

const ProductMoreImages: FC<IProductProps> = ({prodState, prodDispatch}) => {
  const setImages = (value: any[]) => prodDispatch({type: productActionType.set_product_images, payload: {value}})

  return <SortableImages
    images={prodState.product_image || []}
    onChange={setImages}
    onRemove={(index, remaining) => {
      // Records a live product's gallery row in deleted_images before the list is replaced.
      prodDispatch({type: productActionType.product_image, payload: {id: 'product_image', value: 'remove', index}})
      setImages(remaining)
    }} />
}

export default ProductMoreImages
